import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../../Styles/ColoresManager.css';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { catColorNormalize } from '../../../Objetos/ColoresModel';

export default function ColoresManagerModal({ open, mode, data, onClose, onSubmit, usedIds = [] }) {
    const [variables, setVariables] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [isLoadingVars, setIsLoadingVars] = useState(false);

    const [form, setForm] = useState({
        nombre: '',
        descripcion: '',
        idCatColor: '',
        variable: '',
        valor: '#3c00be',
        activo: true,
        idCategoria: null
    });

    useEffect(() => {
        if (open) {
            const fetchVars = async () => {
                setIsLoadingVars(true);
                try {
                    const [resVars, resCats] = await Promise.all([
                        axios.get(ENDPOINTS.catColores),
                        axios.get(ENDPOINTS.catCategorias)
                    ]);
                    const listVars = (resVars.data || []).map(catColorNormalize);
                    setVariables(listVars);
                    const listCats = (resCats.data || []).map(c => ({
                        idCategoria: c.idCategoria || c.IdCategoria,
                        nombre: c.nombre || c.Nombre
                    }));
                    setCategorias(listCats);
                } catch (e) {
                    console.error("Error loading resources:", e);
                } finally {
                    setIsLoadingVars(false);
                }
            };
            fetchVars();
        }
    }, [open]);

    useEffect(() => {
        if (open) {
            if (mode === 'edit' && data) {
                setForm({
                    nombre: data.nombre || '',
                    descripcion: data.descripcion || '',
                    idCatColor: data.idCatColor || '',
                    variable: data.variable || '',
                    valor: data.valor || '#3c00be',
                    activo: data.activo ?? true,
                    idCategoria: data.idCategoria || null
                });
            } else {
                setForm({
                    nombre: '',
                    descripcion: '',
                    idCatColor: '',
                    variable: '',
                    valor: '#3c00be',
                    activo: true,
                    idCategoria: null
                });
            }
        }
    }, [open, mode, data]);

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleVariableChange = (id) => {
        const idInt = parseInt(id);
        const selected = variables.find(v => v.idColor === idInt);
        setForm(prev => ({
            ...prev,
            idCatColor: idInt,
            variable: selected ? selected.variable : ''
        }));
    };

    const handleHexChange = (e) => {
        let val = e.target.value;
        if (!val.startsWith('#')) val = '#' + val;
        handleChange('valor', val);
    };

    if (!open) return null;

    const isFormValid = form.nombre && form.idCatColor && form.idCatColor !== '' && form.idCatColor !== 0;

    return (
        <div className="colores-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} style={{ zIndex: 9999, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%' }}>
            <div className="colores-modal-content">
                <div className="colores-modal-header">
                    <h3 className="colores-modal-title">
                        {mode === 'new' ? 'Nueva Asignación de Color' : 'Editar Asignación'}
                    </h3>
                    <button className="colores-modal-close" onClick={onClose}>×</button>
                </div>

                <div className="colores-modal-body">
                    <div className="color-editor-primary-row">
                        <div className="color-picker-wrapper">
                            <div className="color-picker-preview" style={{ backgroundColor: form.valor }} />
                            <input
                                type="color"
                                className="color-input-real"
                                value={form.valor.length === 7 ? form.valor : '#3c00be'}
                                onChange={(e) => handleChange('valor', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Código Hexadecimal</label>
                            <input
                                className="form-input token-input"
                                value={form.valor}
                                onChange={handleHexChange}
                                maxLength={7}
                                placeholder="#000000"
                                style={{
                                    color: '#334155',
                                    borderColor: form.valor,
                                    fontFamily: 'monospace',
                                    fontWeight: '700',
                                    boxShadow: `0 0 0 1px ${form.valor}20`
                                }}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Variable a Definir (Token)</label>
                        <select
                            className="form-input"
                            value={form.idCatColor}
                            onChange={(e) => handleVariableChange(e.target.value)}
                            disabled={isLoadingVars}
                            style={{ fontFamily: 'monospace', fontWeight: 600 }}
                        >
                            <option value="">-- Seleccionar Variable --</option>
                            {variables.filter(v => {
                                if (mode === 'edit' && data && v.idColor === data.idCatColor) return true;
                                return !usedIds.includes(v.idColor);
                            }).map(v => (
                                <option key={v.idColor} value={v.idColor}>{v.variable} ({v.nombre})</option>
                            ))}
                        </select>
                    </div>

                    {/* Informative Read-Only Fields (Text Only) */}
                    <div className="form-group" style={{ marginTop: '0.25rem' }}>
                        <label className="form-label" style={{ fontSize: '0.7rem', color: '#94a3b8', marginBottom: '0.25rem' }}>Nombre de esta Instancia</label>
                        <div style={{ color: '#1e293b', fontWeight: 600, fontSize: '1rem' }}>
                            {form.nombre || '(Sin nombre)'}
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label" style={{ fontSize: '0.7rem', color: '#94a3b8', marginBottom: '0.25rem' }}>Categoría</label>
                        <div style={{ color: '#1e293b', fontWeight: 600, fontSize: '1rem' }}>
                            {categorias.find(c => c.idCategoria === form.idCategoria)?.nombre || 'Sin Categoría'}
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label" style={{ fontSize: '0.7rem', color: '#94a3b8', marginBottom: '0.25rem' }}>Descripción de Uso</label>
                        <div style={{
                            color: '#64748b',
                            fontSize: '0.9rem',
                            lineHeight: '1.5',
                            fontStyle: form.descripcion ? 'normal' : 'italic'
                        }}>
                            {form.descripcion || 'Sin descripción detallada.'}
                        </div>
                    </div>
                </div>

                <div className="colores-modal-footer">
                    <button className="roles-btn" onClick={onClose} style={{ borderRadius: '12px' }}>Cancelar</button>
                    <button
                        className="btn-action"
                        onClick={() => onSubmit(form, mode)}
                        disabled={!isFormValid}
                        style={{
                            opacity: (!isFormValid) ? 0.5 : 1,
                            borderRadius: '12px',
                            padding: '0.75rem 2rem',
                            cursor: (!isFormValid) ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {mode === 'new' ? 'Registrar Asignación' : 'Guardar Cambios'}
                    </button>
                </div>
            </div>
        </div>
    );
}
